export default { 
    'PPTlist.Document':'演讲稿',
    'PPTlist.noDataTips': '未找到相关结果',
    'PPTlist.Edited':'最近编辑',
    'PPTlist.delModel.ok':'确认',
    'PPTlist.delModel.cancel':'取消',
    'PPTlist.delModel.title':'删除文档',
    'PPTlist.delModel.content':'删除后将无法找回。',
}